// extracted by mini-css-extract-plugin
module.exports = {"batteryTechnology":"BatteryTechnology_batteryTechnology__jM4R4"};